<template>
  <!-- Modal -->
  <div>
    <div class="modal fade" id="ArchivePurchaseModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold">追加</h5>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <table class="table table-striped table-align-middle">
              <thead>
                <tr>
                  <th>見積データ</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <select class="custom-select" v-model="selectedID">
                      <option selected>-</option>
                      <option
                        v-for="(order, i) in orderData.list"
                        :key="i"
                        :value="order.id"
                      >{{ order.name }}</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
          </div>
          <div class="modal-footer justify-content-between">
            <div>
              <a class="btn btn-link decoration-underline" href="/new-orders">新規登録画面へ</a>
            </div>
            <div>
              <button ref="closeAddEstimate" type="button" class="btn btn-secondary" data-dismiss="modal">閉じる</button>&nbsp;
              <button
                type="button"
                class="btn btn-primary"
                @click="addToEstimate()"
              >更新</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'

export default {
  name: 'ArchivePurchaseModal',
  props: {},
  components: {
    VueElementLoading
  },
  data () {
    return {
      orderData: [],
      selectedID: null,
      isSearching: false
    }
  },
  created () {
    this.getOrderData()
  },
  methods: {
    async getOrderData () {
      try {
        await this.$http.post(this.$api_url.orders_get_estimate).then(order => {
          if (order.data && order.data.status === true) {
            this.orderData = order.data
          } else {
            if (order.data.message) {
              this.$toastr.error(order.data.message, 'エラー')
            } else {
              this.$toastr.error(order.data, 'エラー')
            }
          }
        })
      } catch (error) {
        console.log('ArchiveSales:API:ordesSimpleList:error: ', error)
      }
    },

    addToEstimate () {
      if (this.selectedID != null) {
        this.isSearching = true

        this.addParams = {
          estimate_id: this.selectedID
        }

        try {
          this.$http.post(this.$api_url.add_from_estimate, this.addParams).then(result => {
            if (result.data && result.data.status === true) {
              this.$toastr.success('見積データを更新しました', 'Success')
              const btn = this.$refs.closeAddEstimate
              btn.click()
            } else {
              this.$toastr.error(result.data.message, 'エラー')
            }
            this.isSearching = false
          })
        } catch (error) {
          console.log('error: ', error)
          this.$toastr.error('エラーが発生しました。ご確認後再試行してください。', 'エラー')
          this.isSearching = false
        }
      }
    }
  }
}
</script>
